<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="card-title">Görevlerim</div>
      </div>
      <div class="card-body p-0">
        <div class="border-top border-bottom p-1">
          <div class="row">
            <div class="col-sm-3">
              <div class="form-group">
                <small class="text-sm text-uppercase font-semibold"
                  >Başlangıç</small
                >
                <flat-pickr
                  class="form-control"
                  v-model="datasource.filter.start_date"
                  :config="{
                    enableTime: true,
                    altFormat: 'd.m.Y H:i',
                    altInput: true,
                    dateFormat: 'Y-m-d H:i',
                    locale: 'tr',
                  }"
                />
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <small class="text-sm text-uppercase font-semibold"
                  >Bitiş</small
                >
                <flat-pickr
                  class="form-control"
                  v-model="datasource.filter.end_date"
                  :config="{
                    enableTime: true,
                    altFormat: 'd.m.Y H:m',
                    altInput: true,
                    dateFormat: 'Y-m-d H:m',
                    locale: 'tr',
                  }"
                />
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <small class="text-sm text-uppercase font-semibold"
                  >Görev Türü</small
                >
                <v-select
                  v-model="datasource.filter.task_type"
                  :options="task_types"
                  :reduce="(option) => option.value"
                  :searchable="false"
                  :clearable="false"
                />
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <small class="text-sm text-uppercase font-semibold"
                  >Görev Durumu</small
                >
                <v-select
                  v-model="datasource.filter.status"
                  :options="task_status"
                  :reduce="(option) => option.value"
                  :searchable="false"
                  :clearable="false"
                />
              </div>
            </div>
            <div v-if="false" class="col-sm-3">
              <div class="form-group">
                <small class="text-sm text-uppercase font-semibold">İl</small>
                <v-select
                  v-model="datasource.filter.city_id"
                  :options="global.cities"
                  :reduce="(curr) => curr.value"
                  v-on:input="changeCity()"
                  :searchable="true"
                  :clearable="true"
                />
              </div>
            </div>
            <div v-if="false" class="col-sm-3">
              <div class="form-group">
                <small class="text-sm text-uppercase font-semibold">İlçe</small>
                <v-select
                  v-model="datasource.filter.district_id"
                  :options="datasource.districts"
                  :reduce="(curr) => curr.district_id"
                  :searchable="true"
                  :clearable="true"
                />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <small class="text-sm text-uppercase font-semibold"
                  >Görevler</small
                >
                <v-select
                  v-model="datasource.filter.task_definition_id"
                  :options="task_todo"
                  :reduce="(option) => option.value"
                  :searchable="true"
                  :clearable="false"
                />
              </div>
            </div>
            <div class="col-sm-2">
              <div class="form-group mt-2">
                <button class="btn btn-primary" @click="filter()">
                  Uygula
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="">
          <b-table
            ref="table_task_list"
            responsive
            striped
            small
            hover
            :select-mode="'single'"
            selectable
            :items="datasource.tasks"
            :fields="table_fields"
            @row-selected="setTask"
            :tbody-tr-class="rowClass"
            class="mb-0 align-top"
            show-empty
          >
            <template #cell(task_id)="data">
              <div class="font-weight-bolder">
                <div>#{{ data.item.task_id }}</div>
              </div>
            </template>

            <template #cell(task_name)="data">
              <div>
                <div class="font-weight-bolder">{{ data.item.task_name }}</div>
                <small>{{ data.item.priority_text }}</small>
              </div>
            </template>
            <template #cell(task_definition)="data">
              <div class="font-weight-bold">
                {{ data.value }}
              </div>
            </template>
            <template #cell(device_name)="data">
              <div>
                {{ data.value }}
              </div>
            </template>
            <template #cell(staff_item)="data">
              <div v-if="data.value != null">
                {{ data.value.user_namesurname }}
              </div>
              <div v-if="data.item.staff_item_complated != null">
                <span>Tamamlayan</span>
                <span class="ml-1">{{
                  data.item.staff_item_complated.user_namesurname
                }}</span>
              </div>
            </template>
            <template #cell(date_item)="data">
              <div>
                <div class="font-medium">Planlanan Tarih:</div>
                <div>
                  <span v-if="data.item.planned_date != ''">
                    {{
                      moment(data.item.planned_date).format("DD.MM.YYYY HH:mm")
                    }}
                  </span>
                </div>
              </div>
              <div class="mt-05rem" v-if="data.item.status == 'complated'">
                <div class="font-medium">Tamamlanma Tarihi:</div>
                <div>
                  <span v-if="data.item.complated_date != ''">
                    {{
                      moment(data.item.complated_date).format(
                        "DD.MM.YYYY HH:mm"
                      )
                    }}
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
            </template>
            <template #cell(status_item)="data">
              <status-badge :status="data.value" />
            </template>
            <template #empty>
              <div class="pt-3 pb-3 text-center">
                Listelenecek bir kayıt bulunmuyor.
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <task-detail-modal></task-detail-modal>
  </div>
</template>

<script>
import TaskDetailModal from "./TaskDetailModal.vue";
import StatusBadge from "@/views/common/StatusBadge.vue";
import { VueAutosuggest } from "vue-autosuggest";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { tr } from "flatpickr/dist/l10n/tr.js";
import api from "@/service/api";
import utils from "@/service/utils";
import _ from "lodash";
import { mapState, mapGetters } from "vuex";
import moment from "moment";
export default {
  components: {
    StatusBadge,
    VueAutosuggest,
    vSelect,
    flatPickr,
    TaskDetailModal,
  },
  data() {
    return {
      datasource: {
        users: [],
        tasks: [],
        task: null,
        filter: {
          start_date: null,
          end_date: null,
          task_type: "all",
          status: "",
          task_definition_id: '',
          staff_id: 0,
          city_id: 0,
          district_id: 0,
        },
        districts: [],
        table: {
          fields: [
            {
              key: "task_id",
              label: "No",
              sortable: true,
              selected: true,
              show_to: ["all", "task", "delivery", "device_repair"],
            },
            {
              key: "task_name",
              label: "Görev",
              sortable: true,
              selected: true,
              show_to: ["all", "task", "delivery", "device_repair"],
            },
            {
              key: "city_district",
              label: "İl/İlçe",
              sortable: true,
              selected: true,
              show_to: ["delivery"],
            },
            {
              key: "customer",
              label: "Müşteri",
              sortable: true,
              selected: true,
              show_to: ["delivery"],
            },
            {
              key: "device_name",
              label: "Cihaz",
              sortable: true,
              selected: true,
              show_to: ["all", "delivery", "device_repair"],
            },
            {
              key: "date_item",
              label: "Tarih",
              sortable: false,
              tdClass: "minw14rem pr-0 pl-1",
              thClass: "minw14rem pr-0 pl-1",
              show_to: ["all", "task", "delivery", "device_repair"],
            },
            {
              key: "status_item",
              label: "Durum",
              sortable: true,
              show_to: ["all", "task", "delivery", "device_repair"],
            },
          ],
          selected: null,
        },
      },
    };
  },
  methods: {
    getUsers() {
      api.action("getUsers").then((q) => {
        if (q.success) {
          this.datasource.users = q.data;
        }
      });
    },
    filter() {
      let postData = this.datasource.filter;
      postData.staff_id = utils.getActiveUser().user_id;
      postData.only_my_task = 1;
      api.action("getTasks", { ...postData }).then((q) => {
        if (!q.success) {
          utils.notificationToast("warning", "Bilgi", q.message);
          return;
        }
        let items = [];
        q.data.forEach((qq) => {
          qq.city_district = null;
          if (qq.delivery_item != null) {
            qq.city_district =
              qq.delivery_item.city_text + "/" + qq.delivery_item.district_text;
          }

          qq.device_name = null;
          if (qq.device_item != null) {
            qq.device_name = qq.device_item.device_name;
          }

          console.log("qq", qq);
          items.push(qq);
        });
        this.datasource.tasks = items;
      });
    },
    setTask(item) {
      item = item[0];
      if (item) {
        this.sf.task = item;
        if (item.device_item != null) {
          this.sf.device = item.device_item;
        }
        if (item.delivery_item != null) {
          this.sf.delivery = item.delivery_item;
        }
      }
      this.$bvModal.show("modal_task_detail");
    },
    rowClass(item, type) {
      if (!item || type !== "row") {
        return;
      }
    },
    moment(v) {
      return moment(v);
    },
    changeCity() {
      this.datasource.filter.district_id = 0;
      this.datasource.districts = [];
      this.getDistricts();
    },
    getDistricts() {
      let city_id = this.datasource.filter.city_id;
      let items = utils.getDistricts(city_id, { viewtype: "vselect" });
      this.datasource.districts = items;
    },
  },
  created() {
    this.getUsers();
    this.datasource.filter.start_date = utils.moment().format("YYYY-MM-DD");
    this.datasource.filter.end_date = utils.moment().format("YYYY-MM-DD");
  },
  computed: {
    ...mapState({
      sf: (state) => state.sf,
      global: (state) => state.global,
    }),
    task_status() {
      let result = [];
      result.push({ label: "Tümü", value: "" });
      result.push(...this.global.task_status);
      return result;
    },
    task_types() {
      let result = [];
      result.push({ label: "Tümü", value: "all" });
      result.push(...this.global.task_types);
      return result;
    },
    task_todo() {
      let result = [];
      result.push({ label: "Tümü", value: "" });
      result.push(...this.global.task_todo);
      return result;
    },
    list_service_task() {
      let result = [];
      return result;
    },
    table_fields() {
      let d = this.datasource.filter.task_type;
      console.log("d", d);
      let result = this.datasource.table.fields.filter((q) =>
        q.show_to.includes(d)
      );
      return result;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>